import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AlertService } from 'src/app/Services/alert.service';
import { UserDataProviderService } from 'src/app/Services/user-data-provider.service';
import { MaterialModule } from 'src/app/Shared/MaterialModule/material/material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule,RouterOutlet, RouterLink, TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  userFormGroup: FormGroup;
  submitted = false;
  constructor(
    private titleService: Title,
    private formBuilder: FormBuilder, private userDataProviderService: UserDataProviderService, private alertService: AlertService, private translate: TranslateService) {
    this.userFormGroup = this.formBuilder.group({
      userEmail: ['', [Validators.required, Validators.email]]
    });
    this.titleService.setTitle('Forgot password - Spendkey');
  }


  sendRecoveryLink() {
    this.submitted = true;
    if (this.userFormGroup.invalid) return;

    const requestBody = {
      UserEmail: this.userFormGroup.controls['userEmail'].value
    };

    this.userDataProviderService.resetPassword(requestBody).subscribe((response: any) => {
      if (response.status == 'success') {
        this.alertService.openAlert(this.translate.instant('Password reset link has been sent !'), 'success');
        this.userFormGroup.reset();
        this.submitted = false;
      } else {
        this.alertService.openAlert(response.error, 'error');
        this.submitted = false;
      }
    });
  }
}
